export function currencyDigits(symbol: string) {
	if (/^(yen|JP¥|¥)$/.test(symbol)) return `2.0-0`;
	return "1.2-2";
}
